import { useState } from 'react';
import { FAQPageLD } from '@/components/base/SEO';

const faqData = [
  {
    question: '西瓜视频免费在线观看需要注册吗？',
    answer: '不需要注册即可免费观看。桔子视频提供西瓜视频、丝瓜视频等平台的高清资源聚合，用户无需注册登录就可以直接在线观看电视剧、电影、综艺、动漫等各类视频内容，极速加载不缓冲。',
  },
  {
    question: '为什么西瓜视频播放不缓冲？',
    answer: '桔子视频采用先进的CDN内容分发和P2P加速技术，智能适配网络环境进行码率调节，确保用户在不同网络条件下都能获得流畅不缓冲的观影体验。同时我们持续优化服务器性能，保障高清画质下的流畅播放。',
  },
  {
    question: '丝瓜视频和西瓜视频有什么区别？',
    answer: '西瓜视频和丝瓜视频都是热门的在线视频平台。西瓜视频资源更全面，覆盖电视剧、电影、综艺、动漫等多个品类且更新及时；丝瓜视频则在原创内容和独家版权方面有独特优势。桔子视频为您聚合了两大平台的优质资源。',
  },
  {
    question: '西瓜视频支持哪些设备观看？',
    answer: '桔子视频完美适配电脑、平板和手机等多种设备。您可以通过浏览器直接访问，无需下载任何APP。响应式设计确保在不同屏幕尺寸下都能获得舒适的观影体验。推荐使用Chrome、Safari等主流浏览器获得最佳效果。',
  },
  {
    question: '电视剧更新速度快吗？',
    answer: '非常快。桔子视频与各大平台保持同步更新，热播剧集上线后第一时间更新，确保您不错过任何精彩内容。对于热门电视剧，我们还会提供全集观看入口，让您可以一次性追完所有剧集，无需等待。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100/50">
      <div className="max-w-3xl mx-auto">
        <FAQPageLD questions={faqData} />
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8" style={{ fontFamily: 'var(--font-heading)' }}>
          常见问题
        </h2>
        <div className="space-y-3">
          {faqData.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-lg bg-background-100 border border-background-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between p-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-950 pr-4">{faq.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-200 ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === idx && (
                <div className="px-4 pb-4">
                  <p className="text-sm text-foreground-500 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}